import { createQuery, request } from '@luna/api';

import type { AddressSearchResponse } from './AddressSearchTypes';
import { getPlacesAutocompleteUrl, isValidSearchQuery } from './AddressSearchService';

export const [useAddressSearch] = createQuery({
    name: 'contact-data-management/addresses',
    cacheKey: (query) => query,
    condition: (query) => isValidSearchQuery(query),
    payloadCreator: async (query: string) => {
        const response = await request<AddressSearchResponse>(getPlacesAutocompleteUrl(query));
        return response.autocompletePlaces;
    },
});
